import { getRecaptchaToken, recaptchaAction } from './recaptcha';

const readResponseMessage = async (response) => {
  const contentType = response.headers?.get?.('content-type') || '';
  if (contentType.includes('application/json')) {
    const body = await response.json().catch(() => null);
    return { body, message: body?.message || body?.msg || body?.error?.message || body?.error || '' };
  }
  const text = await response.text().catch(() => '');
  return { body: null, message: text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() };
};

export const submitMauticLead = async (endpoint, payload, fallbackMessage) => {
  const recaptchaToken = await getRecaptchaToken();
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      recaptcha_token: recaptchaToken,
      recaptcha_action: recaptchaAction,
    }),
  });
  const { body, message } = await readResponseMessage(response);
  if (!response.ok || body?.status !== 'success' || !body?.contactId) throw new Error(message || fallbackMessage);
  return body;
};
